import { useEffect } from 'react';
import '../../styles/HomeComponents/Roadmap.css';
import roadmapImage1 from '../../assets/Images/Group271.webp';  
import roadmapImage2 from '../../assets/Images/Group272.webp';    
import roadmapImage3 from '../../assets/Images/Group273.webp';    
import roadmapImage4 from '../../assets/Images/Group274.webp';    

const Roadmap = () => {

  useEffect(() => {
    if (window.innerWidth < 600) {
      const heading = document.querySelector('.roadmap-heading');
      if (heading) {
        heading.innerHTML = "Unlock your potential with personalized learning experiences tailored just for you";
      }
    }
  }, []);

  return (
    <section className="roadmap-container">
      <h2 className="roadmap-heading">
        Unlock your potential with <br />
        personalized learning experiences <br />
        tailored just for you
      </h2>


      <div className="roadmap-feature">
        <div className="roadmap-text left">
          <span className="roadmap-step-number">01</span>
          <h3>Real-time progress tracking:</h3>
          <p>
            Get clear insights on how you're improving with performance using live performance
            tracking. Track progress, celebrate milestones, and stay motivated.
          </p>
        </div>
        <div className="roadmap-image">
          <img src={roadmapImage1} alt="Progress Graph" />
        </div>
      </div>

      <div className="roadmap-feature reverse">
        <div className="roadmap-image">
          <img src={roadmapImage2} alt="Dashboard UI" />
        </div>
        <div className="roadmap-text right">
          <span className="roadmap-step-number">02</span>
          <h3>All-in-one-place:</h3>
          <p>
            Intuitive dashboards to manage tasks, view schedules, complete pending actions, and
            make payments effortlessly.
          </p>
        </div>
      </div>
      <div className="roadmap-feature">
        <div className="roadmap-text left">
          <span className="roadmap-step-number">03</span>
          <h3>State-of-the-art learning experience:</h3>
          <p>
            Discover new workshops & master classes, keep track of schedules, and get personalised reports every month. Ask questions, get feedback personally from the instructors, and enjoy lessons designed just for you!
          </p>
        </div>
        <div className="roadmap-image">
          <img src={roadmapImage3} alt="Progress Graph" />
        </div>
      </div>

      <div className="roadmap-feature reverse">
        <div className="roadmap-image">
          <img src={roadmapImage4} alt="Dashboard UI" />
        </div>
        <div className="roadmap-text right">
          <span className="roadmap-step-number">04</span>
          <h3>Easy Schedule Management</h3>
          <p>
            No more juggling class times! Set, adjust, and manage your learning schedule effortlessly in one place.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Roadmap;
